import { useLazyFetchDashboardRequestsQuery } from '@api/selfServe';

const useDashboardRequests = () => {
  const [getDashboardRequests, { isLoading, isError }] = useLazyFetchDashboardRequestsQuery();

  const getDashboardRequestsData = async (
    search?: string,
    pageNumber?: number,
    pageSize?: number,
    archived: boolean = false,
    portfolio: boolean = false,
    selectedStatuses: string[] = [],
    selectedDataSources: string[] = [],
  ) => {
    const qps: Array<string> = [];

    if (search !== undefined && search.length !== 0) {
      qps.push(`search=${search}`);
    }

    if (pageNumber !== undefined) {
      qps.push(`pageNumber=${pageNumber}`);
    }

    if (pageSize !== undefined) {
      qps.push(`pageSize=${pageSize}`);
    }

    qps.push(`sort=updatedAt`);
    qps.push(`sortOrder=DESC`);
    if (archived === false) {
      qps.push(`archived=${archived}`);
    }

    if (portfolio === false) {
      qps.push(`type=INDIVIDUAL`);
    }

    if (selectedStatuses.length) {
      selectedStatuses.forEach((status) => {
        qps.push(`status=${status}`);
      });
    }

    if (selectedDataSources.length) {
      selectedDataSources.forEach((source) => {
        qps.push(`mmp=${source}`);
      });
    }

    try {
      const response = await getDashboardRequests(qps.join('&')).unwrap();
      if (response?.data) {
        return response.data;
      }

      return null;
    } catch (err) {
      console.error(err);
    }
  };

  return { getDashboardRequestsData, isLoading, isError };
};

export default useDashboardRequests;
